import React from "react";
import { SharedImgixAndSourceProps } from "react-imgix";

import Imgix from "react-imgix/es/react-imgix"; // TODO: lazy load

import * as styles from "./ImgixImage.module.scss";
import { isPresent } from "src/utils/checks";
import clsx from "clsx";

export interface ImgixImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  image: SharedImgixAndSourceProps | undefined;
  className?: string;
  fit?: "crop" | "original";
  width?: number;
  height?: number;
}

const getLocalizedAlt = (
  localizedAlt: { localized: string } | string | undefined
): string | undefined => {
  if (!localizedAlt) return;

  if (typeof localizedAlt !== "string" && "localized" in localizedAlt)
    return localizedAlt.localized;

  return localizedAlt as string;
};

const isImgixImagePresent = (
  image: SharedImgixAndSourceProps | undefined
): image is SharedImgixAndSourceProps => {
  return isPresent(image) && isPresent(image.src);
};

const UncontrolledImgixImage: React.ForwardRefRenderFunction<
  HTMLDivElement,
  ImgixImageProps
> = (
  { image, className, fit = "crop", style, alt, width, height, ...imgTagProps },
  ref
) => {
  const ratioClass = clsx({
    [styles.imageFitCrop]: fit == "crop",
    [styles.imageFitOriginal]: fit == "original"
  });

  if (!isImgixImagePresent(image)) return null;
  if (!isPresent(width) || !isPresent(height)) return null;
  const localizedAlt = getLocalizedAlt(alt);

  return (
    <div ref={ref} className={clsx([ratioClass, className])} style={style}>
      <Imgix
        {...image}
        width={width}
        height={height}
        htmlAttributes={{
          ...imgTagProps,
          alt: localizedAlt
        }}
        imgixParams={{
          fit: fit == "crop" ? "crop" : undefined,
          devicePixelRatio: 1
        }}
      />
    </div>
  );
};

export const ImgixImage = React.memo(React.forwardRef(UncontrolledImgixImage));
